import { apiRequest } from './client.js';
import type { User, Device, Entitlement } from '@hisob/types';
import type { CursorPaginatedResult } from '../types/index.js';

export async function fetchUsers(params?: {
  limit?: number;
  cursor?: string;
  status?: string;
  search?: string;
}): Promise<CursorPaginatedResult<User>> {
  return apiRequest<CursorPaginatedResult<User>>('/api/v1/admin/users', { params });
}

export async function fetchUserById(userId: string): Promise<User> {
  return apiRequest<User>(`/api/v1/admin/users/${userId}`);
}

export async function fetchUserDevices(userId: string): Promise<Device[]> {
  const res = await apiRequest<{ items: Device[] }>(`/api/v1/admin/users/${userId}/devices`);
  return res.items || [];
}

export async function fetchUserEntitlements(userId: string): Promise<Entitlement[]> {
  const res = await apiRequest<{ items: Entitlement[] }>(`/api/v1/admin/users/${userId}/entitlements`);
  return res.items || [];
}

